<template>

    <div class="shadow overflow-hidden">

      <div>

        <dl>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.employee') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.employee_name }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.careerpath') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.career_path_name }}
            </dd>
          </div>
          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.startdate') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.start_date }}
            </dd>
          </div>
          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.decreenumb') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.decree_no }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.decreeExpiredDate') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.decree_expire_date }}
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.created_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.created_by }}
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.updated_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.updated_by }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.created_at') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.created_at }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('employeecareerpath.updated_at') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ employeecareerpath.updated_at }}
            </dd>
          </div>

        </dl>
      </div>

    </div>

    </template>
    <script>
    // /* eslint-disable */
    import { ref, reactive, watchEffect } from 'vue'
    export default {
      name: 'EmployeeCareerPath Detail Form',
      components: {

      },
      props: {
        propObject: {
          type: Object,
          default: () => ({ empty: true })
        },
        propClass: {
          type: Object,
          default: () => ({ empty: true })
        }
      },
      data: function () {
        return {
        }
      },
      emits: ['close-modal', 'submit'],
      setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        // const activeTab = ref(0)

        const employeecareerpath = reactive({
          id: '',
          employee_name: '',
          career_path_name: '',
          decree_no: '',
          start_date: '',
          created_by: '',
          created_at: ''

        })

        watchEffect(() => {
          const newemployeecareerpath = props.propObject
          Object.assign(employeecareerpath, newemployeecareerpath)
        })

        return {
          titleStack,
          employeecareerpath
        }
      }
    }
    </script>
